<template>
  <div class="zkml-login" @keyup.enter="login">
    <div class="bg1"></div>
    <div class="login-content">
      <div class="title-view">
        <span class="title">云书·仪表盘运营管理后台</span>
      </div>
      <div class="content">
        <img class="left" src="@/assets/images/loginBg2.png" />
        <div class="right">
          <div class="login-text">加入团队</div>
          <div class="tips">
            {{
              isHaveManager
                ? '请选择团队身份进入'
                : '选择并加入所在单位，成为管理员，为您的团队发布资料吧~'
            }}
          </div>
          <div class="list-area">
            <div
              class="item"
              :class="{
                'loading-item': loading && loadId === item.organizationId,
              }"
              v-for="(item, index) in organizationList"
              :key="index"
              @click="toMain(item)"
            >
              <div class="name">
                {{ item.organizationName }}
              </div>
              <div
                class="loading-view"
                v-if="loading && loadId === item.organizationId"
                v-loading="loading"
              ></div>
              <template v-else>
                <img class="hover-icon" src="@/assets/images/right.png" />
                <img class="icon" src="@/assets/images/right2.png" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="联系管理员"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <div class="dialog-content">
        <span class="flex-row">
          点击查看
          <el-popover placement="bottom" width="250" trigger="click">
            <div style="font-size: 12px">
              <div style="margin-bottom: 5px">
                管理员: {{ manager.nickName }}（{{ manager.phone }}）
              </div>
              <div>{{ deptName }}</div>
            </div>
            <el-link slot="reference" type="primary">管理员</el-link>
          </el-popover>
          信息，呼唤他为您的团队发布资料吧~
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Config from '@/utils/config';
import Cache from '@/utils/cache';

export default {
  name: 'organization',
  data() {
    return {
      visible: false,
      manager: {},
      loading: true,
      loadId: null,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    organizationList() {
      return this.userInfo.organizationList || [];
    },
    isHaveManager() {
      return this.organizationList.some((item) => item.managerStaffId !== null);
    },
    deptName() {
      const { fatherDeptName, deptName } = this.manager;
      return `${fatherDeptName ? fatherDeptName + '/' : ''}${deptName || ''}`;
    },
  },
  mounted() {
    if (this.organizationList.length === 1) {
      this.toMain(this.organizationList[0]);
    }
  },
  methods: {
    closeDialog() {
      this.visible = false;
      this.$store.dispatch('app/loginOutNoFetch');
    },
    async toMain(item) {
      const params = {
        authId: this.userInfo.authId,
        organizationId: item.organizationId,
        organizationName: item.organizationName,
        requestSource: 'BACKGROUND_MANAGEMENT',
      };
      this.loading = true;
      this.loadId = item.organizationId;
      const res = await this.$http.post(
        this.$API.set_organization_post,
        params,
      );
      this.loading = false;
      this.loadId = null;
      if (res?.data) {
        this.$store.dispatch('app/updateStaffId', res.data.staffId);
        Cache.set(Config.STAFFID, res.data.staffId);
        Cache.set(Config.CURRENTORGID, item.organizationId);
        this.$router.push({ path: '/dashboardManagement/groupList' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.zkml-login {
  .bg1 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('~@/assets/images/loginBg1.png') center no-repeat;
    background-size: 100% 100%;
  }
  .login-content {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title-view {
      display: flex;
      justify-content: center;
      align-items: center;
      .title {
        margin-left: 16px;
        font-size: 40px;
        font-weight: bold;
        color: #303133;
      }
    }
    .content {
      display: flex;
      margin-top: 37px;
      .left {
        width: 460px;
        height: 500px;
      }
      .right {
        width: 460px;
        height: 500px;
        box-sizing: border-box;
        background-color: #fff;
        padding: 40px;
        .login-text {
          font-size: 30px;
          font-weight: bold;
          color: #303133;
        }
        .tips {
          font-size: 14px;
          font-weight: 400;
          color: #606266;
          margin-top: 20px;
          margin-bottom: 40px;
        }
        .list-area {
          max-height: 323px;
          overflow-y: auto;
        }
        .item {
          width: 380px;
          height: 64px;
          margin-bottom: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 12px;
          border: 1px solid #ccd0d8;
          padding: 0 20px;
          font-size: 16px;
          .icon {
            width: 20px;
          }
          .hover-icon {
            display: none;
            width: 20px;
          }
          .loading-view {
            width: 30px;
            height: 30px;
            padding-top: 10px;
            ::v-deep .el-loading-spinner {
              top: 0;
              margin-top: 0;
              .circular {
                width: 30px;
                height: 30px;
              }
            }
          }
        }
        .loading-item {
          border-color: #2f70ff;
          color: #2f70ff;
          cursor: pointer;
        }
        .item:hover {
          border-color: #2f70ff;
          color: #2f70ff;
          cursor: pointer;
          .icon {
            display: none;
          }
          .hover-icon {
            display: block;
          }
        }
      }
    }
  }
  .dialog-content {
    .flex-row {
      display: flex;
      ::v-deep .el-link--inner {
        font-size: 16px;
        font-weight: normal;
        padding-bottom: 3px;
      }
    }
  }
}
</style>
